// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import setupAxiosInterceptors from './utils/axiosConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './css/tailwind.css';
import './css/custom.css';
import './css/cards.css';
import './css/buttons.css';
import './css/forms.css';
import './css/loading.css';
import './css/preloader.css';
import './css/template-navbar.css';
import './css/FuelManagement.css';
// Loaded LAST on purpose: the global design system re-points every legacy
// design token and normalises all shared primitives (type, surfaces, tables,
// forms, buttons, modals, responsive rules) onto one calm visual language.
import './css/design-system.css';

setupAxiosInterceptors();

// One-time migration: remove stale service workers/caches that can serve old CSS bundles.
const runOneTimeCacheMigration = async () => {
  if (typeof window === 'undefined') {
    return;
  }

  const CACHE_MIGRATION_FLAG = 'cache_migration_20260302_done';
  const CACHE_MIGRATION_RELOAD_FLAG = 'cache_migration_20260302_reloaded';

  try {
    const migrated = localStorage.getItem(CACHE_MIGRATION_FLAG) === 'true';
    if (migrated) {
      return;
    }

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ('caches' in window) {
      const cacheKeys = await window.caches.keys();
      await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
    }

    localStorage.setItem(CACHE_MIGRATION_FLAG, 'true');

    // Force one reload so the page is no longer under stale SW control.
    if (sessionStorage.getItem(CACHE_MIGRATION_RELOAD_FLAG) !== 'true') {
      sessionStorage.setItem(CACHE_MIGRATION_RELOAD_FLAG, 'true');
      window.location.reload();
      return;
    }
  } catch (error) {
    console.warn('Cache migration skipped:', error);
  } finally {
    sessionStorage.removeItem(CACHE_MIGRATION_RELOAD_FLAG);
  }
};

runOneTimeCacheMigration();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('Service Worker registered successfully.', registration);

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'NOTIFICATION_CLICKED' && event.data.url) {
        window.dispatchEvent(
          new CustomEvent('navigate-to', {
            detail: { path: event.data.url }
          })
        );
      }
    });
  },
  subscribeForPush: true
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    console.log('Received message from service worker:', event.data);
  });
}
